import { useCallback, useEffect } from 'react';
import {
  useCreateCustomerLockMutation,
  useLazyGetCustomerActiveLocksQuery,
  useLazyGetCustomerLockItemAuditLogsQuery,
  useLazyGetCustomerLockItemQuery,
  useLazyGetCustomerLocksQuery,
  useUpdateCustomerLockMutation,
} from '../../store/services/individual';

const useLockForm = ({ userId }: { userId?: string }) => {
  const [getLockItem, { isLoading, isFetching }] =
    useLazyGetCustomerLockItemQuery();
  const [getLocks] = useLazyGetCustomerLocksQuery();
  const [create, { isLoading: requestInProgress, isSuccess }] =
    useCreateCustomerLockMutation();
  const [update, { isLoading: updateInProgress, isSuccess: updateIsSuccess }] =
    useUpdateCustomerLockMutation();
  const [
    getList,
    { isFetching: lockItemLogsIsFetching, isLoading: lockItemLogsIsLoading },
  ] = useLazyGetCustomerLockItemAuditLogsQuery();
  const [getCustomerActiveLock] = useLazyGetCustomerActiveLocksQuery();

  const getCustomerActiveLockAction = useCallback(() => {
    getCustomerActiveLock(userId as string);
  }, []);

  useEffect(() => {
    if (isSuccess || updateIsSuccess) {
      getCustomerActiveLockAction();
    }
  }, [isSuccess, updateIsSuccess]);

  return {
    getLockItem,
    getLocks,
    create,
    update,
    isSuccess,
    isLoading,
    isFetching,
    requestInProgress,
    updateInProgress,
    getList,
    lockItemLogsIsLoading,
    lockItemLogsIsFetching,
  };
};

export default useLockForm;
